import { createSlice } from '@reduxjs/toolkit';
import { IInitAction, IInitResolveAction, IRunNewExportResolveAction, IWorkOrderState } from './types';

const initialState: IWorkOrderState = {
  workOrderId: undefined,
  workOrderDetails: {
    Id: '',
    WorkOrderId: '',
    ProjectName: '',
    ClientName: '',
    WorkDate: undefined,
    AgsExportConfigurationName: '',
  },
  pageHeader: {
    identifier: '',
    shortName: 'AGS Data',
    description: '',
    status: '',
    processing: false,
  },
  exportHistory: [],
  status: {
    ready: false,
    errorMessage: undefined,
    busyState: false,
  },
};

const slice = createSlice({
  name: 'workOrder',
  initialState,
  reducers: {
    init: (state, action: IInitAction) => {
      const { payload: { workOrderId } = {} } = action;

      state.status.ready = false;
      state.status.errorMessage = undefined;
      state.status.busyState = false;

      state.workOrderId = workOrderId;
    },
    initResolve: (state, action: IInitResolveAction) => {
      state.workOrderDetails = action.payload.WorkOrder;
      state.pageHeader.identifier = action.payload.WorkOrder.WorkOrderId;
      state.pageHeader.description = 'AGS Data for ' + action.payload.WorkOrder.WorkOrderId;

      state.exportHistory = action.payload.AgsExports.flatMap((x) => x.Revisions);
      state.status.ready = true;
    },
    initReject: (state) => {
      state.status.errorMessage = 'The Work Order could not be found, please check that the ID is correct.';
      state.pageHeader.identifier = '';
      state.pageHeader.description = '';
      state.status.ready = true;
    },

    runNewExport: (state) => {
      state.status.busyState = true;
    },
    runNewExportResolve: (state, action: IRunNewExportResolveAction) => {
      state.exportHistory = action.payload.Revisions;
      state.status.busyState = false;
    },
    runNewExportReject: (state) => {
      state.status.busyState = false;
    },
  },
});

export const { actions, reducer } = slice;
export default slice.reducer;
